
import { useState } from 'react';
import { ref, set, remove } from 'firebase/database';
import { database } from '../firebase/firebase';
import { Expense, SponsorExpense } from '../types';

export const useExpenses = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const updateExpense = async (eventId: string, expense: Expense | SponsorExpense): Promise<void> => {
        setLoading(true);
        setError(null);

        try {
            // Update to use eventExpenses structure
            const expenseRef = ref(database, `eventExpenses/${eventId}/${expense.id}`);

            const updatedExpense = {
                ...expense,
                lastModified: Date.now(),
                lastModifiedBy: expense.createdBy
            };

            // Remove undefined values (Firebase doesn't accept undefined)
            Object.keys(updatedExpense).forEach(key => {
                if ((updatedExpense as any)[key] === undefined) {
                    delete (updatedExpense as any)[key];
                }
            });

            await set(expenseRef, updatedExpense);
        } catch (err) {
            setError('Failed to update expense');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const deleteExpense = async (eventId: string, expenseId: string): Promise<void> => {
        setLoading(true);
        setError(null);

        try {
            // Update to use eventExpenses structure
            const expenseRef = ref(database, `eventExpenses/${eventId}/${expenseId}`);
            await remove(expenseRef);
        } catch (err) {
            setError('Failed to delete expense');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    // Add new expense function
    const addExpense = async (eventId: string, expense: Expense): Promise<void> => {
        setLoading(true);
        setError(null);

        try {
            // Add to eventExpenses structure
            const expenseRef = ref(database, `eventExpenses/${eventId}/${expense.id}`);
            await set(expenseRef, expense);
        } catch (err) {
            setError('Failed to add expense');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return {
        addExpense,
        updateExpense,
        deleteExpense,
        loading,
        error
    };
};